import { Joi } from 'app-webtech-core/schemas';
import { actionCreator } from 'app-webtech-core/actions/actionCreator';
import { VOLUME_CHANGE } from '../actions/types';
import { volumeChangeWithoutBeacon } from './volumeChangeNoBeacon';

const payloadSchema = Joi.object().keys({
  up: Joi.boolean().required(),
  level: Joi.number().required(),
});

const volumeChange = actionCreator(VOLUME_CHANGE, payloadSchema);

export const volumeChangeThunkAction = (payload) => (dispatch) => {
  if (payload && payload.noBeacon) {
    return dispatch(volumeChangeWithoutBeacon(payload));
  }
  return dispatch(volumeChange(payload));
};
